import THDStorageUtils, { LOCAL_STORAGE } from '@thd-olt-global/thd-storage-utils';
import { FALLBACK_USER_ID, PAGE_TYPES } from '../components/MagicApronAssistant/constants';

export const getMcvisID = () => {
  return typeof window !== 'undefined'
    ? window.THDCustomer?.default?.mcvisID || FALLBACK_USER_ID : FALLBACK_USER_ID;
};

export const getSvocId = () => {
  return typeof window !== 'undefined' ? window.THDCustomer?.default?.svocID || null : null;
};

export const getUserName = () => {
  return typeof window !== 'undefined' ? window.THDCustomer?.default?.name || null : null;
};

export const getParentPagePath = () => {
  return typeof window !== 'undefined'
    ? new URL(window.parent.document.documentURI).pathname
    : '';
};

export const getPageType = () => {
  const pathArray = getParentPagePath().split('/');

  if (pathArray[1] === 'c') return PAGE_TYPES.CONTENT;
  if (pathArray[1] === 'p') {
    if (pathArray[2] === 'sets') return PAGE_TYPES.BIP;
    return PAGE_TYPES.PIP;
  }
  if (pathArray[1] === 's') return PAGE_TYPES.SEARCH;
  if (pathArray[1] === 'b') return PAGE_TYPES.BROWSE;
  if (pathArray[1] === '') return PAGE_TYPES.HOME;

  return PAGE_TYPES.UNKNOWN;
};

export const getItemId = () => {
  if (getPageType() !== PAGE_TYPES.PIP) return null;

  return getParentPagePath().split('/').at(-1);
};

export const getRecentSearchTerms = () => {

  try {
    const history = THDStorageUtils.get(LOCAL_STORAGE, { key: 'header_search_history' });
    if (!history || history === 'undefined') return [];
    return JSON.parse(history).map((term) => {
      try {
        return decodeURIComponent(term.keyword);
      } catch {
        return term.keyword;
      }
    });

  } catch (error) {
    // eslint-disable-next-line no-console
    console.error({
      message: `Error occurred while accessing local storage - ${'header_search_history'}`,
      error
    });
    return [];
  }
};
